import { Coordiate } from '../../entity/location/corodinate';

export class CoordinateTransformer {
    transform(coordinateInfo: any) : Coordiate {
        return new Coordiate(
            coordinateInfo.latitude,
            coordinateInfo.longitude
        )
    }

    deTransform(coordinate: Coordiate) {
        return {
            latitude: coordinate.latitude,
            longitude: coordinate.longitude
        }
    }
}